import { render, staticRenderFns } from "./consumecard.vue?vue&type=template&id=49868b27&scoped=true"
import script from "./consumecard.vue?vue&type=script&lang=js"
export * from "./consumecard.vue?vue&type=script&lang=js"
import style0 from "./consumecard.vue?vue&type=style&index=0&id=49868b27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49868b27",
  null
  
)

export default component.exports